import {defineAsyncComponent} from 'vue';

const inventoryPopup = defineAsyncComponent(() => import('@/views/dictionary/inventory/InventoryDetail.vue'));
const InventoryBatchDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/inventory/InventoryBatchDetail.vue'),
);
const accountDetail = defineAsyncComponent(() => import('@/views/dictionary/account/AccountDetail.vue'));
const selectDatabase = defineAsyncComponent(() => import('@/views/system/SelectDatabasePopup.vue'));
const employeeDetail = defineAsyncComponent(() => import('@/views/dictionary/employee/EmployeeDetail.vue'));
const employeeTypeDetail = defineAsyncComponent(() => import('@/views/dictionary/employeeType/EmployeeTypeDetail.vue'));
const departmentDetail = defineAsyncComponent(() => import('@/views/dictionary/department/DepartmentDetail.vue'));
const departmentQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/department/DepartmentQuickSearch.vue'),
);
const demoFormPopup = defineAsyncComponent(() => import('@/views/demo/DemoFormPopup.vue'));
const systemAccountDetails = defineAsyncComponent(() =>
  import('@/views/dictionary/systemAccounts/SystemAccountDetails.vue'),
);
const renameDataDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dataManagement/createDataDetail/RenameDataDetail.vue'),
);
const deleteDataDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dataManagement/createDataDetail/DeleteDataDetail.vue'),
);

const currencyDetail = defineAsyncComponent(() => import('@/views/dictionary/currency/CurrencyDetail.vue'));
const inventoryCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/inventoryCategory/InventoryCategoryDetail.vue'),
);
const stockDetail = defineAsyncComponent(() => import('@/views/dictionary/stock/StockDetail.vue'));
const budgetChapterDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetChapter/BudgetChapterDetail.vue'),
);

const fixedAssetDetail = defineAsyncComponent(() => import('@/views/dictionary/fixedAsset/FixedAssetDetail.vue'));

const fixedAssetReference = defineAsyncComponent(() => import('@/views/dictionary/fixedAsset/FixedAssetReference.vue'));

const budgetGroupItemDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetGroupItem/BudgetGroupItemDetail.vue'),
);

const typeOfFundDetail = defineAsyncComponent(() => import('@/views/dictionary/typeOfFund/TypeOfFundDetail.vue'));

const bankInfoCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/bankInfoCategorys/BankInfoCategoryDetail.vue'),
);

const budgetSourcePropertyDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetSourceProperty/BudgetSourcePropertyDetail.vue'),
);

const budgetSourceDetail = defineAsyncComponent(() => import('@/views/dictionary/budgetSource/BudgetSourceDetail.vue'));

const bankInfoDetail = defineAsyncComponent(() => import('@/views/dictionary/bankInfo/BankInfoDetail.vue'));

const budgetItemDetail = defineAsyncComponent(() => import('@/views/dictionary/budgetItem/BudgetItemDetail.vue'));

const budgetKindItemDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetKindItem/BudgetKindItemDetail.vue'),
);

const statisticDetail = defineAsyncComponent(() => import('@/views/dictionary/statistic/StatisticDetail.vue'));

const purchasePurposeDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/purchasePurpose/PurchasePurposeDetail.vue'),
);

const accountTransferDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountTransfer/AccountTransferDetail.vue'),
);

const budgetSourceTransferDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetSource/BudgetSourceTransfer.vue'),
);

const budgetKindItemTransferDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetKindItem/BudgetKindItemTransfer.vue'),
);

const activityDetail = defineAsyncComponent(() => import('@/views/dictionary/activity/ActivityDetail.vue'));

const budgetFeesDetail = defineAsyncComponent(() => import('@/views/dictionary/budgetFees/BudgetFeesDetail.vue'));

const customerVendorDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/customerVendor/CustomerVendorDetail.vue'),
);

const accountingObjectCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/accountingObjectCategory/AccountingObjectCategoryDetail.vue'),
);

const invoiceFormNumberDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/invoiceFormNumber/InvoiceFormNumberDetail.vue'),
);

const voucherTypeDetail = defineAsyncComponent(() => import('@/views/dictionary/voucherType/VoucherTypeDetail.vue'));
const contractDetail = defineAsyncComponent(() => import('@/views/dictionary/contract/ContractDetail.vue'));

const taskDetail = defineAsyncComponent(() => import('@/views/dictionary/task/TaskDetail.vue'));
const topicDetail = defineAsyncComponent(() => import('@/views/dictionary/topic/TopicDetail.vue'));

const topicEstimate = defineAsyncComponent(() => import('@/views/dictionary/topic/TopicEstimate.vue'));

const projectDetail = defineAsyncComponent(() => import('@/views/dictionary/project/ProjectDetail.vue'));

const targetProgramDetail = defineAsyncComponent(() => import('@/views/dictionary/project/TargetProgramDetail.vue'));

const projectBudgetDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/projectBudgetDetail/ProjectBudgetDetail.vue'),
);

const workItemDetail = defineAsyncComponent(() => import('@/views/dictionary/project/WorkItemDetail.vue'));

const projectBudgetSubDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/projectBudgetDetail/ProjectBudgetSubDetail.vue'),
);

const projectTransfer = defineAsyncComponent(() => import('@/views/dictionary/project/ProjectTransfer.vue'));

const autoBusinessDetail = defineAsyncComponent(() => import('@/views/dictionary/autoBusiness/AutoBusinessDetail.vue'));

// gửi dữ liệu lên STC Hải Dương
const SendAccountingDataHD = defineAsyncComponent(() => import('@/views/peculiarity/SendAccountingDataHD.vue'));

// thông báo chưa nhập mã địa bàn
const ConfirmSendAccountingDataHD = defineAsyncComponent(() =>
  import('@/views/peculiarity/ConfirmInvalidSendData.vue'),
);

const fundStructureDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/fundStructure/FundStructureDetail.vue'),
);

const defaultAccountDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/defaultAccount/DefaultAccountDetail.vue'),
);
const systemAccountQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/defaultAccount/DefaultAccountDetailQuickSearchPopup.vue'),
);

const budgetSourceQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetSource/BudgetSourceQuickSearchPopup.vue'),
);

const accountParallelRule = defineAsyncComponent(() =>
  import('@/views/dictionary/accountParallelRule/AccountParallelRule.vue'),
);

const payrollItemDetail = defineAsyncComponent(() => import('@/views/dictionary/payrollItem/PayrollItemDetail.vue'));

const salaryScaleDetail = defineAsyncComponent(() => import('@/views/dictionary/salaryScale/SalaryScaleDetail.vue'));

const pAOption = defineAsyncComponent(() => import('@/views/dictionary/pAOption/PAOption.vue'));

const payrollItemFormula = defineAsyncComponent(() => import('@/views/dictionary/payrollItem/PayrollItemFormula.vue'));

const systemAccountsTransfer = defineAsyncComponent(() =>
  import('@/views/dictionary/systemAccounts/SystemAccountsTransfer.vue'),
);
const customerVendorImport = defineAsyncComponent(() =>
  import('@/views/dictionary/customerVendor/CustomerVendorImport.vue'),
);

const customerVendorImportInfo = defineAsyncComponent(() =>
  import('@/views/dictionary/customerVendor/CustomerVendorImportInfoPopup.vue'),
);

const employeePopupChangeRate = defineAsyncComponent(() =>
  import('@/views/dictionary/employee/EmployeePopupChangeRate.vue'),
);

const budgetProvideDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetProvide/BudgetProvideDetail.vue'),
);

const incurredDataPopup = defineAsyncComponent(() => import('@/views/dictionary/incurredData/incurredDataPopup.vue'));

const incurredDataList = defineAsyncComponent(() => import('@/views/dictionary/incurredData/incurredDataList.vue'));

const incurredDataDI = defineAsyncComponent(() => import('@/views/dictionary/incurredData/incurredDataDI.vue'));
const toolTypeDetail = defineAsyncComponent(() => import('@/views/dictionary/toolType/ToolTypeDetail.vue'));

const toolDetail = defineAsyncComponent(() => import('@/views/dictionary/tool/ToolDetail.vue'));

const incurredDataMultiple = defineAsyncComponent(() =>
  import('@/views/dictionary/incurredData/incurredDataMultiple.vue'),
);
const stateBankQuickSearch = defineAsyncComponent(() => import('@/views/dictionary/bankInfo/StateBankQuickSearch.vue'));
const commercialBankQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/commercialBank/CommercialBankQuickSearch.vue'),
);
const stateCustomerQuickSearch = defineAsyncComponent(() =>
  import('@/views/invoice/saleInvoice/StateCustomerQuickSearch.vue'),
);

const incurredFileMultiple = defineAsyncComponent(() =>
  import('@/views/etreasury/incurredFile/incurredFileMultiple.vue'),
);
const LockLedgerVoucher = defineAsyncComponent(() =>
  import('@/views/megaMenuOther/ledgerVoucher/LockLedgerVoucher.vue'),
);
const UnLockLedgerVoucher = defineAsyncComponent(() =>
  import('@/views/megaMenuOther/ledgerVoucher/UnLockLedgerVoucher.vue'),
);
const ProcessLockLedgerVoucher = defineAsyncComponent(() =>
  import('@/views/megaMenuOther/ledgerVoucher/ProcessLockLedgerVoucher.vue'),
);
const PostedVoucher = defineAsyncComponent(() => import('@/views/megaMenuOther/ledgerVoucher/PostedVoucher.vue'));

const managementUser = defineAsyncComponent(() => import('@/views/managementUser/ManagementUserDetail.vue'));
const accountHandOver = defineAsyncComponent(() => import('@/views/managementUser/AccountHandOver.vue'));
const selectUserOver = defineAsyncComponent(() => import('@/views/managementUser/SelectUserOver.vue'));
const userInfoDetail = defineAsyncComponent(() => import('@/views/managementUser/UserInfoDetail.vue'));
const ApproveReportUserPopup = defineAsyncComponent(() => import('@/views/report/ApproveReportUserPopup.vue'));
const ReportSettingPopup = defineAsyncComponent(() => import('@/views/report/ReportSettingPopup.vue'));
const VoucherReportSettingPopup = defineAsyncComponent(() => import('@/views/report/VoucherReportSettingPopup.vue'));
const SystemUserRoleDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/systemUserRole/SystemUserRoleDetail.vue'),
);
const AdvancedSecurityDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/advancedSecurity/AdvancedSecurityDetail.vue'),
);
const SystemPermission = defineAsyncComponent(() => import('@/views/role/RolePage.vue'));

const WarningDate = defineAsyncComponent(() => import('@/views/dictionary/license/WarningDate.vue'));
const ExpireWarning = defineAsyncComponent(() => import('@/views/dictionary/license/ExpireWarningPopup.vue'));
const RegistrationLicense2nd = defineAsyncComponent(() =>
  import('@/views/dictionary/license/RegistrationLicense2nd.vue'),
);

const ExpireDatePopUp = defineAsyncComponent(() => import('@/views/dictionary/license/ExpireDatePopUp.vue'));
const WarningExtendExpired = defineAsyncComponent(() => import('@/views/dictionary/license/WarningExtendExpired.vue'));
const PaymentConfirm = defineAsyncComponent(() => import('@/views/dictionary/license/PaymentConfirm.vue'));
// Component Thỏa thuận sử dụng - DVMINH 04/01/2023 - PBI 178649
const AgreementContract = defineAsyncComponent(() => import('@/views/dictionary/agreement/AgreementContract.vue'));

// Component Banner Esign DVMINH 15/05/2023
const BannerEsignKBPopup = defineAsyncComponent(() => import('@/views/dictionary/esign/BannerEsignKBPopup.vue'));
const BannerEsignHDPopup = defineAsyncComponent(() => import('@/views/dictionary/esign/BannerEsignHDPopup.vue'));
const UserInfoToACHPopup = defineAsyncComponent(() => import('@/views/dictionary/esign/UserInfoToACHPopup.vue'));

const ConfirmAgreementPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/agreement/ConfirmAgreementPopup.vue'),
);
const AgreementNotAllowPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/agreement/AgreementNotAllowPopup.vue'),
);

const fixedAssetCategoryDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/fixedAssetCategory/FixedAssetCategoryDetail.vue'),
);

const AccountingObjectQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/accountingObjectCategory/AccountingObjectQuickSearch.vue'),
);

const BankInfoQuickSearch = defineAsyncComponent(() => import('@/views/dictionary/bankInfo/BankInfoQuickSearch.vue'));

const VoucherTypeQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/voucherType/VoucherTypeQuickSearch.vue'),
);

const BudgetChapterQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetChapter/BudgetChapterQuickSearch.vue'),
);

const BudgetSourcePropertyQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetSourceProperty/BudgetSourcePropertyQuickSearch.vue'),
);

const BudgetKindItemQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetKindItem/BudgetKindItemQuickSearch.vue'),
);

const BudgetItemQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetItem/BudgetItemQuickSearch.vue'),
);

const FixedAssetCategoryQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/fixedAssetCategory/FixedAssetCategoryQuickSearch.vue'),
);
const ProjectQuickSearch = defineAsyncComponent(() => import('@/views/dictionary/project/ProjectQuickSearch.vue'));

const ActivityQuickSearch = defineAsyncComponent(() => import('@/views/dictionary/activity/ActivityQuickSearch.vue'));

const AccountComboQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/account/AccountComboQuickSearch.vue'),
);

const StockQuickSearch = defineAsyncComponent(() => import('@/views/dictionary/stock/StockQuickSearch.vue'));

// Chứng từ liên quan
const InvolveVoucherPopup = defineAsyncComponent(() => import('@/views/dictionary/tool/InvolveVoucherPopup.vue'));
// Bảo trì dữ liệu
const DataMaintenance = defineAsyncComponent(() => import('@/views/settings/datas/DataMaintenance.vue'));

// Sắp xếp lại số chứng từ
const SortRefNo = defineAsyncComponent(() => import('@/views/megaMenuOther/utility/SortRefNo.vue'));
const SortRefNoResultPopup = defineAsyncComponent(() =>
  import('@/views/megaMenuOther/utility/SortRefNoResultPopup.vue'),
);

const RestoreVoucher = defineAsyncComponent(() => import('@/views/megaMenuOther/restoreVoucher/RestoreVoucher.vue'));

const StatisticQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/statistic/StatisticQuickSearch.vue'),
);

const TaskQuickSearch = defineAsyncComponent(() => import('@/views/dictionary/task/TaskQuickSearch.vue'));

const FundStructureQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/fundStructure/FundStructureQuickSearch.vue'),
);

const BudgetProvideQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetProvide/BudgetProvideQuickSearch.vue'),
);

const TopicQuickSearch = defineAsyncComponent(() => import('@/views/dictionary/topic/TopicQuickSearch.vue'));

const ContractQuickSearch = defineAsyncComponent(() => import('@/views/dictionary/contract/ContractQuickSearch.vue'));
const InventoryCategoryQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/inventoryCategory/InventoryCategoryQuickSearch.vue'),
);
const helpSettlement = defineAsyncComponent(() => import('@/views/dictionary/help/HelpSettlement.vue'));

const BudgetFeesQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetFees/BudgetFeesQuickSearch.vue'),
);

const SyncProjectFromBumasPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/project/SyncProjectFromBumasPopup.vue'),
);

const SyncBudgetFeesFromBumasPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/budgetFees/SyncBudgetFeesFromBumasPopup.vue'),
);

const SyncMissionPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/SyncDictionary/SyncMissionFromMimosaPopup.vue'),
);
const SyncProjectPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/SyncDictionary/SyncProjectFromMimosaPopup.vue'),
);
const SyncActivePopup = defineAsyncComponent(() =>
  import('@/views/dictionary/SyncDictionary/SyncActiveFromMimosaPopup.vue'),
);
const CompareBudgetSourcePopup = defineAsyncComponent(() =>
  import('@/views/dictionary/SyncDictionary/CompareBudgetSourcePopup.vue'),
);
const CompareBudgetSourceBumasPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/SyncDictionary/CompareBudgetSourceBumasPopup.vue'),
);
const SelectFixedAssetCategoryPopup = defineAsyncComponent(() =>
  import('@/views/common/circulars/SelectFixedAssetCategoryPopup.vue'),
);
const SyncTaskFromBumasPopup = defineAsyncComponent(() => import('@/views/dictionary/task/SyncTaskFromBumasPopup.vue'));
const SyncBudgetFeesPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/SyncDictionary/SyncBudgetFeesFromMimosaPopup.vue'),
);

const ChooseDatabase = defineAsyncComponent(() => import('@/views/profile/ChooseDatabase.vue'));

const ChooseData = defineAsyncComponent(() => import('@/views/profile/ChooseData.vue'));

const DisplaySetting = defineAsyncComponent(() => import('@/views/displaySetting/DisplaySetting.vue'));

const popupPaymentLicense = defineAsyncComponent(() => import('@/views/paymentLicense/popupPaymentLicense.vue'));

// Sao chép dữ liệu
const CopyDataOther = defineAsyncComponent(() => import('@/views/megaMenuOther/copyData/CopyDataOther.vue'));
// Sao chép dữ liệu Validate Đồng nhất dữ liệu danh mục dqdat1 01.06.2023
const CopyDataValidateDictionary = defineAsyncComponent(() =>
  import('@/views/megaMenuOther/copyData/CopyDataValidateDictionary.vue'),
);
// Sao chép dữ liệu Validate Đồng nhất dữ liệu danh mục chi tiết lttuan1 22.06.2023
const CopyDataValidateDictionaryDetail = defineAsyncComponent(() =>
  import('@/views/megaMenuOther/copyData/CopyDataValidateDictionaryDetail.vue'),
);
// Sao chép dữ liệu Danh sách chi tiết các chứng từ sao chép dqdat1 01.06.2023
const CopyDataDetailList = defineAsyncComponent(() => import('@/views/megaMenuOther/copyData/CopyDataDetailList.vue'));

const CopyDataLoadingPopup = defineAsyncComponent(() =>
  import('@/views/megaMenuOther/copyData/CopyDataLoadingPopup.vue'),
);
const CopyDataCompletePopup = defineAsyncComponent(() =>
  import('@/views/megaMenuOther/copyData/CopyDataCompletePopup.vue'),
);
const ChooseVoucherQuickSearch = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcFile/ChooseVoucherQuickSearch.vue'),
);

const CompanyVoucherQLTS = defineAsyncComponent(() => import('@/views/assetQLTS/popup/CompanyVoucherQLTS.vue'));
const CompanyVoucherSalaGov = defineAsyncComponent(() => import('@/views/assetQLTS/popup/CompanyVoucherSalaGov.vue'));
const ExpiredReportPopup = defineAsyncComponent(() => import('@/views/dictionary/license/ExpiredReportPopup.vue'));
const DownloadConfirmPopup = defineAsyncComponent(() => import('@/views/dictionary/license/DownloadConfirmPopup.vue'));

export function registerDictionary(app) {
  app.component('InventoryDetail', inventoryPopup);
  app.component('AccountDetail', accountDetail);
  app.component('SelectDatabase', selectDatabase);
  app.component('EmployeeDetail', employeeDetail);
  app.component('EmployeeTypeDetail', employeeTypeDetail);
  app.component('DepartmentDetail', departmentDetail);
  app.component('DepartmentQuickSearch', departmentQuickSearch);
  app.component('DemoFormPopup', demoFormPopup);
  app.component('SystemAccountDetails', systemAccountDetails);
  app.component('RenameDataDetail', renameDataDetail);
  app.component('DeleteDataDetail', deleteDataDetail);
  app.component('CurrencyDetail', currencyDetail);
  app.component('InventoryCategoryDetail', inventoryCategoryDetail);
  app.component('StockDetail', stockDetail);
  app.component('BudgetChapterDetail', budgetChapterDetail);
  app.component('FixedAssetDetail', fixedAssetDetail);
  app.component('FixedAssetReference', fixedAssetReference);
  app.component('FixedAssetCategoryDetail', fixedAssetCategoryDetail);
  app.component('BudgetProvideDetail', budgetProvideDetail);
  app.component('StatisticDetail', statisticDetail);
  app.component('BudgetGroupItemDetail', budgetGroupItemDetail);
  app.component('BudgetSourcePropertyDetail', budgetSourcePropertyDetail);
  app.component('BudgetSourceDetail', budgetSourceDetail);
  app.component('BudgetSourceQuickSearch', budgetSourceQuickSearch);
  app.component('TypeOfFundDetail', typeOfFundDetail);
  app.component('BankInfoCategoryDetail', bankInfoCategoryDetail);
  app.component('BudgetSourceTransfer', budgetSourceTransferDetail);
  app.component('BudgetKindItemTransfer', budgetKindItemTransferDetail);
  app.component('ActivityDetail', activityDetail);
  app.component('BudgetFeesDetail', budgetFeesDetail);

  app.component('BankInfoDetail', bankInfoDetail);
  app.component('BudgetItemDetail', budgetItemDetail);
  app.component('BudgetKindItemDetail', budgetKindItemDetail);
  app.component('PurchasePurposeDetail', purchasePurposeDetail);
  app.component('AccountTransferDetail', accountTransferDetail);
  app.component('CustomerVendorDetail', customerVendorDetail);
  app.component('AccountingObjectCategoryDetail', accountingObjectCategoryDetail);
  app.component('InvoiceFormNumberDetail', invoiceFormNumberDetail);
  app.component('VoucherTypeDetail', voucherTypeDetail);
  app.component('ProjectDetail', projectDetail);
  app.component('TargetProgramDetail', targetProgramDetail);
  app.component('ProjectBudgetDetail', projectBudgetDetail);
  app.component('ContractDetail', contractDetail);
  app.component('TaskDetail', taskDetail);
  app.component('TopicDetail', topicDetail);
  app.component('TopicEstimate', topicEstimate);
  app.component('WorkItemDetail', workItemDetail);
  app.component('ProjectBudgetSubDetail', projectBudgetSubDetail);
  app.component('ProjectTransfer', projectTransfer);
  app.component('AutoBusinessDetail', autoBusinessDetail);
  app.component('FundStructureDetail', fundStructureDetail);
  app.component('AccountParallelRule', accountParallelRule);
  app.component('DefaultAccountDetail', defaultAccountDetail);
  app.component('SystemAccountQuickSearch', systemAccountQuickSearch);
  app.component('PayrollItemDetail', payrollItemDetail);
  app.component('SalaryScaleDetail', salaryScaleDetail);
  app.component('PAOption', pAOption);
  app.component('PayrollItemFormula', payrollItemFormula);
  app.component('SystemAccountsTransfer', systemAccountsTransfer);
  app.component('CustomerVendorImport', customerVendorImport);
  app.component('CustomerVendorImportInfo', customerVendorImportInfo);
  app.component('EmployeePopupChangeRate', employeePopupChangeRate);
  app.component('IncurredDataPopup', incurredDataPopup);
  app.component('IncurredDataList', incurredDataList);
  app.component('IncurredDataDI', incurredDataDI);
  app.component('IncurredDataMultiple', incurredDataMultiple);
  app.component('ToolTypeDetail', toolTypeDetail);
  app.component('ToolDetail', toolDetail);
  app.component('StateBankQuickSearch', stateBankQuickSearch);
  app.component('StateCustomerQuickSearch', stateCustomerQuickSearch);
  app.component('IncurredFileMultiple', incurredFileMultiple);
  app.component('LockLedgerVoucher', LockLedgerVoucher);
  app.component('UnLockLedgerVoucher', UnLockLedgerVoucher);
  app.component('PostedVoucher', PostedVoucher);
  app.component('ProcessLockLedgerVoucher', ProcessLockLedgerVoucher);
  app.component('ManagementUserDetail', managementUser);
  app.component('AccountHandOver', accountHandOver);
  app.component('SelectUserOver', selectUserOver);
  app.component('UserInfoDetail', userInfoDetail);
  app.component('SystemUserRoleDetail', SystemUserRoleDetail);
  app.component('WarningDate', WarningDate);
  app.component('ExpireWarning', ExpireWarning);
  app.component('RegistrationLicense2nd', RegistrationLicense2nd);
  app.component('ExpireDatePopUp', ExpireDatePopUp);
  app.component('WarningExtendExpired', WarningExtendExpired);
  app.component('PaymentConfirm', PaymentConfirm);
  app.component('SystemPermission', SystemPermission);
  app.component('AccountingObjectQuickSearch', AccountingObjectQuickSearch);
  app.component('BankInfoQuickSearch', BankInfoQuickSearch);
  app.component('VoucherTypeQuickSearch', VoucherTypeQuickSearch);
  app.component('BudgetChapterQuickSearch', BudgetChapterQuickSearch);
  app.component('ConfirmAgreementPopup', ConfirmAgreementPopup);
  app.component('AgreementContract', AgreementContract);
  app.component('AgreementNotAllowPopup', AgreementNotAllowPopup);
  app.component('BannerEsignKBPopup', BannerEsignKBPopup);
  app.component('BannerEsignHDPopup', BannerEsignHDPopup);
  app.component('UserInfoToACHPopup', UserInfoToACHPopup);

  app.component('BudgetSourcePropertyQuickSearch', BudgetSourcePropertyQuickSearch);
  app.component('BudgetKindItemQuickSearch', BudgetKindItemQuickSearch);
  app.component('BudgetItemQuickSearch', BudgetItemQuickSearch);
  app.component('ProjectQuickSearch', ProjectQuickSearch);
  app.component('FixedAssetCategoryQuickSearch', FixedAssetCategoryQuickSearch);
  app.component('ActivityQuickSearch', ActivityQuickSearch);
  app.component('AccountComboQuickSearch', AccountComboQuickSearch);
  app.component('StockQuickSearch', StockQuickSearch);
  app.component('InvolveVoucherPopup', InvolveVoucherPopup);
  app.component('StatisticQuickSearch', StatisticQuickSearch);
  app.component('TaskQuickSearch', TaskQuickSearch);
  app.component('FundStructureQuickSearch', FundStructureQuickSearch);
  app.component('BudgetProvideQuickSearch', BudgetProvideQuickSearch);
  app.component('TopicQuickSearch', TopicQuickSearch);
  app.component('ContractQuickSearch', ContractQuickSearch);
  app.component('InventoryCategoryQuickSearch', InventoryCategoryQuickSearch);
  app.component('BudgetFeesQuickSearch', BudgetFeesQuickSearch);
  app.component('DataMaintenance', DataMaintenance);
  app.component('SortRefNo', SortRefNo);
  app.component('RestoreVoucher', RestoreVoucher);
  app.component('SortRefNoResultPopup', SortRefNoResultPopup);
  app.component('HelpSettlement', helpSettlement);
  app.component('SendAccountingDataHD', SendAccountingDataHD);
  app.component('ConfirmSendAccountingDataHD', ConfirmSendAccountingDataHD);
  app.component('SyncProjectFromBumasPopup', SyncProjectFromBumasPopup);
  app.component('SyncBudgetFeesFromBumasPopup', SyncBudgetFeesFromBumasPopup);
  app.component('SyncProjectPopup', SyncProjectPopup);
  app.component('SyncMissionPopup', SyncMissionPopup);
  app.component('SyncActivePopup', SyncActivePopup);
  app.component('CompareBudgetSourcePopup', CompareBudgetSourcePopup);
  app.component('CompareBudgetSourceBumasPopup', CompareBudgetSourceBumasPopup);
  app.component('SelectFixedAssetCategoryPopup', SelectFixedAssetCategoryPopup);
  app.component('SyncBudgetFeesPopup', SyncBudgetFeesPopup);
  app.component('SyncTaskFromBumasPopup', SyncTaskFromBumasPopup);
  app.component('ChooseDatabase', ChooseDatabase);
  app.component('ChooseData', ChooseData);
  app.component('DisplaySetting', DisplaySetting);
  app.component('popupPaymentLicense', popupPaymentLicense);
  app.component('InventoryBatchDetail', InventoryBatchDetail);
  app.component('CopyDataOther', CopyDataOther);
  app.component('CopyDataValidateDictionary', CopyDataValidateDictionary);
  app.component('CopyDataValidateDictionaryDetail', CopyDataValidateDictionaryDetail);
  app.component('CopyDataLoadingPopup', CopyDataLoadingPopup);
  app.component('CopyDataCompletePopup', CopyDataCompletePopup);
  app.component('CopyDataDetailList', CopyDataDetailList);
  app.component('ApproveReportUserPopup', ApproveReportUserPopup);
  app.component('ReportSettingPopup', ReportSettingPopup);
  app.component('VoucherReportSettingPopup', VoucherReportSettingPopup);
  app.component('AdvancedSecurityDetail', AdvancedSecurityDetail);
  app.component('CommercialBankQuickSearch', commercialBankQuickSearch);
  app.component('ChooseVoucherQuickSearch', ChooseVoucherQuickSearch);
  app.component('CompanyVoucherQLTS', CompanyVoucherQLTS);
  app.component('CompanyVoucherSalaGov', CompanyVoucherSalaGov);
  app.component('ExpiredReportPopup', ExpiredReportPopup);
  app.component('DownloadConfirmPopup', DownloadConfirmPopup);
}
